'use strict';

function timestampToDate(timestamp) {
  return new Date(timestamp);
}

module.exports = timestampToDate;
//# sourceMappingURL=timestampToDate.cjs.map
